<template>
  <div
    id="index"
    v-cloak
  >
    <div class="visible-xs min_index">
      <header class="flex_center m_header">
        <i
          class="esc"
          @click="goBackward"
        ><img
            src="@/assets/img/esc_fan.png"
            alt=""
          ></i>
        <h4 class="header_title">评论</h4>
        <i
          class="rigth_button"
          @click.stop="state = true"
          v-if="!state"
        >
          管理
        </i>
        <span
          class="rigth_button"
          v-else
          @click.stop="state = false"
        >
          取消
        </span>
      </header>
      <!-- 内容 -->
      <div class='integral_div'>
        <div
          class="list_ul"
          v-if="list_ul.length>0"
        >
          <div
            class="list_li flex_between "
            :class="{'selsected':liem.is_selected&&state,'unread':!state}"
            @click='detailsFun(index,liem)'
            v-for="(liem,index) in list_ul"
            :key="index"
          >
            <i
              class="gou_icon"
              v-if="state"
            >
              <img
                v-if="!liem.is_selected"
                src="@/assets/img/gou.png"
                alt=""
              >
              <img
                v-else
                src="@/assets/img/gouT.png"
                alt=""
              >
            </i>
            <div class="list_li_text flex_between">
              <h5 class="li_time">
                {{liem.create_time}}
              </h5>
              <div
                class="li_text"
                v-if="liem.type == 1"
                v-html="liem.content"
              >

              </div>
              <div
                class="li_text"
                v-if="liem.type == 2"
              >
                <img
                  :src="liem.content"
                  alt=""
                >
              </div>
            </div>
          </div>
        </div>
        <div
          class="no_center flex_center"
          v-else
        >
          <i v-if="is_loading"><img
              src="@/assets/img/comments_icon.jpg"
              alt=""
            ></i>
          <div
            class="flex_center prompt_text"
            v-if="is_loading"
          >
            暂无评论，前往推荐看看吧! <a
              href="javaScript:void(0)"
              @click.stop="geHome"
            >推荐</a>
          </div>
          <div
            v-else
            class="flex_center prompt_text"
          >
            加载中...
          </div>
        </div>
      </div>
      <div
        class="bottom_button flex_between"
        v-if="state"
      >
        <div
          class="flex_center button_left"
          @click="reinstall(1)"
        >
          <i> <img
              v-if="!is_selected"
              src="@/assets/img/gou.png"
              alt=""
            >
            <img
              v-else
              src="@/assets/img/gouT.png"
              alt=""
            >
          </i>
          全选
        </div>
        <button
          class="flex_center button_right"
          @click="delFun"
          :class="{'point':selsected_arr.length>0}"
        >删除</button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/js/swiper.animate1.0.3.min.js";
import "@/assets/css/animate.min.css";
import "@/assets/css/video-js.min.css";

export default {
  name: "my_comments",
  data () {
    return {
      user: {},//用户信息
      state: false,//是否管理
      list_ul: [],
      is_selected: false,//全选
      selsected_arr: [],//删除
      page: 1,
      is_loading: false,//加载
    };
  },
  computed: {},
  components: {

  },
  watch: {

  },
  methods: {
    delFun () {
      if (this.selsected_arr.length <= 0) {
        return false;
      }
      let that = this;
      layer.open({
        content: '确定要删除吗？'
        , style: 'background-color:#fff; color:#33333;font-size:18px; border:none;' //自定风格
        , btn: ['确定', '取消']
        , yes: function (index) {
          // location.reload();
          layer.close(index);
          that.$post('comment_del', {
            comment_id: that.selsected_arr.join(","),
            member_id: that.USER().id,
          }).then(res => {
            layer.open({
              content: "删除成功",
              time: true,
              skin: "msg"
            });
            that.state = false;
            that.page = 1;
            that.getList();
          })
        }
      });
    },
    detailsFun (index,item) {

      if (this.state) {
        this.list_ul[index].is_selected = !this.list_ul[index].is_selected;
        this.reinstall();
      } else {
        if (item.news_id !== 0) {
          this.$router.push({ path: '/m_column_details', query: { id: item.news_id, head_index: 2 } });
        } else if (item.video_id !== 0) {
          this.$router.push({ path: '/m_vedio_dteil', query: { id: item.video_id, configid: item.conf_id } });
        } else if (item.meeting_id !== 0) {

        }
      }

    },
    reinstall (type) {//组装数据
      this.selsected_arr = [];
      let that = this;
      this.list_ul.forEach((element, index) => {
        if (type == 1 && !this.is_selected) {
          that.list_ul[index].is_selected = true;
        }
        if (type == 1 && this.is_selected) {
          that.list_ul[index].is_selected = false;
        }
        if (that.list_ul[index].is_selected) {
          that.selsected_arr.push(element.id);
        }
      });
      if (this.selsected_arr.length >= this.list_ul.length) {
        this.is_selected = true;
      } else {
        this.is_selected = false;
      }
    },
    geHome () {//返回首页
      this.$router.replace('/');
    },
    goBackward () {//返回上一页
      this.$router.go(-1)
    },
    getUser () {
      let that = this;
      this.REFRESH_USER();
      that.user = this.USER();
      this.getList();
    },
    getList () {
      let that = this;
      if (this.page == 1) {
        this.list_ul = [];
      }
      this.$post('follow_comment', {
        type: 1,//1评论2关注3收藏
        member_id: this.USER().id,
        limit: 10,
        page: this.page,
      }).then(res => {
        that.is_loading = true;
        if (res.data.data) {
          res.data.data.forEach((element, index) => {
            res.data.data[index].is_selected = false;
          });
        }
        that.list_ul = that.list_ul.concat(res.data.data);
      })
    },

  },
  mounted () {
    this.getUser();
    this.getShare();

    if (this._isMobile()) {

    } else {
      // alert("pc端");
      this.$router.replace("/");
    }
    let that = this;
    $(window).scroll(function () {
      var scrollTop = $(this).scrollTop();
      var scrollHeight = $(document).height();
      var windowHeight = $(this).height();
      if (scrollTop + windowHeight + 2 >= scrollHeight) {
        that.page++;
        that.getList();
      }
    });
  }
};
</script>

<style scoped>
html,
body {
  max-width: 100vw;
  background: #f9fbfe;
}

.visible-xs {
  width: 100vw;
  overflow: hidden;
  padding-top: 0rem;
}

/* 内容 */
.list_ul {
  background: #f9fbfe;
}

.list_ul .list_li {
  position: relative;
  padding: 1.8rem 1.4rem 1.8rem 2.4rem;
  background: #fff;
  border-bottom: 0.05rem solid #dfdfdf;
}

.list_ul .list_li .list_li_text {
  width: 100vw;
  align-items: flex-start;
}

.list_ul .list_li.unread .list_li_text::after {
  content: "";
  position: absolute;
  top: 2.3rem;
  left: 1.5rem;
  width: 0.4rem;
  height: 0.4rem;
  border-right: 50%;
  background: #333333;
}

.list_ul .list_li .li_time {
  font-size: 1.2rem;
  color: #999;
  transform: translateY(0.2rem);
}

.list_ul .list_li .li_text {
  font-size: 1.3rem;
  color: #666;
  flex: 1;
  margin-left: 1rem;
}

.list_ul .list_li .li_text img {
  max-width: 60%;
}

.list_ul .list_li .bottom_li {
  margin-top: 1rem;
}

.list_ul .list_li .bottom_li .tag_li {
  margin-right: 1.4rem;
}

.list_ul .list_li .bottom_li .tag_li i {
  width: 1.6rem;
  margin-right: 0.6rem;
  font-size: 1.2rem;
  color: #999;
}

.list_ul .list_li .gou_icon {
  width: 1.8rem;
  height: 1.8rem;
  margin-right: 1rem;
}

.list_ul .list_li .li_icon {
  width: 6.5rem;
  height: 6.5rem;
  margin-bottom: 2rem;
}

.list_ul .list_li > h4 {
  font-size: 1.8rem;
  font-weight: bold;
  color: #f5ab16;
}

/* 底部按钮 */
.bottom_button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4.5rem;
  background: #fff;
  box-shadow: 0 0 9px rgba(71, 71, 71, 0.11);
}

.bottom_button .button_left {
  padding-left: 1.5rem;
  height: 100%;
  font-size: 1.4rem;
  color: #999;
}

.bottom_button .button_left > i {
  width: 1.4rem;
  margin-right: 0.9rem;
}

.bottom_button .button_right {
  width: 15rem;
  height: 100%;
  background: #bfbfbf;
  color: #fff;
  font-size: 1.4rem;
  border: 0;
}

.bottom_button .button_right.point {
  background: #f24d5b;
}

/* 暂无数据 */
.no_center {
  flex-direction: column;
  padding-top: 50vh;
  transform: translateY(-50%);
}

.no_center > i {
  width: 80vw;
  margin-bottom: 2.5rem;
}

.no_center .prompt_text {
  font-size: 1.4rem;
  color: #666;
}

.no_center .prompt_text > a {
  color: #f24d5b;
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/min_view/m_comments.vue